/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Tue Mar 12 2024
 **/

import { useSetAtom } from "jotai";
import { useEventHandler } from "@rfice/eventhandler";

import { InviteSpaceMemberAtom } from "./atom";
import { EventID } from "@/frameworks/core/commons";

export default function OpenInviteSpaceMemberProvider() {
	const setSpaceInfo = useSetAtom(InviteSpaceMemberAtom);

	useEventHandler(EventID.OPEN_INVITE_SPACE_MEMBER, (spaceInfo: WebServices.Space.Detail.Data) => {
		setSpaceInfo(spaceInfo);
	});

	return null;
}
